import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
// Assets
import GenericMap from "@/assets/Mapsicle Map.webp";

export default function UbicacionEmpresaOptions({ info }) {
  return (
    <>
    <div className="relative w-full h-36 sm:h-28 mb-2">
        <div className="absolute w-full h-full bg-aw-bluedark-50 flex flex-col gap-y-2 items-center justify-center px-4">
          <span className="text-xs text-white line-clamp-1">
            Ubicación:{" "}
            <span className="font-medium">
              <FontAwesomeIcon icon={faMapMarkerAlt} className="text-red-500" />{" "}
              {info.textUbicacion}
            </span>
          </span>
        </div>
        <img
          src={GenericMap}
          alt="Mapa de ubicación"
          className="w-full h-full object-cover rounded-lg"
        />
      </div>
      <div className="w-full flex flex-col sm:flex-row items-center justify-between space-y-2 sm:space-x-2 sm:space-y-0">
        {info.opcionesLlegada.map((i, index) => (
          <a
          key={index}
          href={i.url != null ? i.url : "#"}
          target={i.url != null? "_blank" : ""}
          className="bg-transparent border border-gray-300 w-full block text-center text-gray-300 font-semibold rounded-lg px-6 py-2 hover:bg-aw-green hover:border-aw-green hover:text-aw-bluedark transition text-sm">
            {i.label}
          </a>
        ))}
      </div>
    </>
  );
}